import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import CodeInfo from '../components/CodeInfo';

var FunctionTerm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FunctionTerm, _React$Component);

  function FunctionTerm() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FunctionTerm.prototype;

  _proto.getFunctionNameComponent = function getFunctionNameComponent(name) {
    return name.replace(/\((.*?)\)/g, function (value, params) {
      var replacedName = params.split(',').map(function (param) {
        return "<span class=\"param\">" + param + "</span>";
      });
      return "(" + replacedName + ")";
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        deprecated = _this$props.deprecated,
        override = _this$props.override,
        name = _this$props.name,
        codeInfo = _this$props.codeInfo;
    return /*#__PURE__*/React.createElement("h4", {
      className: "title"
    }, deprecated ? /*#__PURE__*/React.createElement("span", {
      className: "signiture deprecated"
    }, "deprecated") : null, override ? /*#__PURE__*/React.createElement("span", {
      className: "signiture override"
    }, "override") : null, /*#__PURE__*/React.createElement("span", {
      className: "name",
      dangerouslySetInnerHTML: {
        __html: this.getFunctionNameComponent(name)
      }
    }), /*#__PURE__*/React.createElement(CodeInfo, {
      data: codeInfo
    }));
  };

  return FunctionTerm;
}(React.Component);

export default FunctionTerm;